import BaseComponent from '../abstracts/BaseComponent';
import 'jquery/dist/jquery.js'
import magnify from 'magnify/dist/js/jquery.magnify.js';
import 'magnify/dist/js/jquery.magnify-mobile.js';
import {match} from '../utilities/ResolutionHandler';

export default class ImageZoomerComponent extends BaseComponent {

  get SELECTORS() {
    return {
      zoom: '.zoom',
      modal: '#zoomModal',
      openModal: '.js-open-modal',
      modalImage: '.catalog-detail__modal-image'
    }
  }

  constructor(element) {
    super(element);
    this.init();
    this.openModal();
    this.closeModal();
  }

  init() {
    const img = this.$el.querySelector(this.SELECTORS.zoom);
    $(img).magnify();
  }

  openModal() {
    let currentSize = this.getMediaQuery(currentSize);
    if (currentSize !== 'large') return;

    this.$el.parentNode.addEventListener("click", (e) => {
      e.preventDefault();
      const modal = document.querySelector(this.SELECTORS.modal);
      const modalImg = modal.querySelector(this.SELECTORS.modalImage);
      const modalCloseButton =  modal.querySelector('.close');
      modal.classList.remove('hide');
      modalImg.src = e.currentTarget.href;
      modalCloseButton.focus();
    })

  }

  closeModal() {
    let currentSize = this.getMediaQuery(currentSize);
    if (currentSize !== 'large') return;

    const modal = document.querySelector(this.SELECTORS.modal);
    const modalCloseButton =  modal.querySelector('.close');
    modalCloseButton.addEventListener("click", (e) => {
      modal.classList.add('hide');
    });
  }

  getMediaQuery(currentSize) {
    if (match('medium', 'small')) {
      currentSize = 'small';
    } else if (match('large', 'medium')) {
      currentSize = 'medium';
    } else if (match(null, 'large')) {
      currentSize = 'large';
    }
    return currentSize;
  }

}
